import { render, staticRenderFns } from "./PlanCrud.vue?vue&type=template&id=1770e14a"
import script from "./PlanCrud.vue?vue&type=script&lang=js"
export * from "./PlanCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports